<template>
  <div class="grayBlock web_pic_item" @click="toArticle">
    <div v-if="article.video" class="video">
      <div class="iframe">
        <div v-html="article.video" />
      </div>
    </div>
    <div v-else class="img">
      <img :src="article.image" :alt="article.title" />
    </div>
    <div class="content">
      <!-- 國際趨勢 / 新聞轉載 -->
      <div class="tag" :class="{
          backgroundColor_advice: article.type === '專家建議',
          backgroundColor_submit: article.type === '達人投稿',
          backgroundColor_workplace: article.type === '職場資訊',
          backgroundColor_employment: article.type === '返國就業',
          backgroundColor_startBusiness: article.type === '返國創業',
        }">
        <p :style="{ fontSize: fontSize.p + 'em' }">{{ article.type }}</p>
      </div>
      <div class="title text_content">
        <h3 :style="{ fontSize: fontSize.h5 + 'em' }">
          {{ article.title }}
        </h3>
      </div>
      <div class="date">
        <p :style="{ fontSize: fontSize.p + 'em' }">
          {{ article.date }}
        </p>
      </div>
      <div class="words ellipsis">
        <p style="white-space: pre-wrap" :style="{ fontSize: fontSize.p + 'em' }" v-html="article.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
// 無障礙文字子層引入設定
import { inject } from "vue";
import { useRouter } from "vue-router";

//Props in, Event out
export default {
  name: "GrayBlock",
  props: {
    justify: {
      type: String,
      required: true,
    },
    countryId: {
      type: String,
      default() {
        return "";
      },
    },
    article: {
      type: Object, //{type: string; title: string; date: string; content: string; previewScreen: string},
      required: true,
    },
  },
  setup(props) {
    let fontSize = inject("fontSize");
    const router = useRouter();

    const toArticle = () => {
      router.push({
        name: props.justify,
        params: { pageId: props.article.pageId },
        query: { countryId: props.countryId },
      });
    };
    return {
      fontSize,
      toArticle,
    };
  },
};
</script>

<style lang="scss" scoped>
.grayBlock {
  background-color: $bgc_gray;
  display: flex;
  justify-content: flex-start;
  padding: 25px;
  margin-bottom: 25px;
  cursor: pointer;

  .img {
    width: 470px;
    height: 180px;

    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
    }
  }
  .content {
    padding: 0 20px;
    width: -webkit-fill-available;
    div {
      padding-bottom: 5px;
    }
    .tag {
      background-color: $black_color;
      color: #fff;
      padding: 3px 10px;
      width: 90px;
      &.backgroundColor_advice {
        background-color: #026764;
      }
      &.backgroundColor_submit {
        background-color: #026764;
      }
      &.backgroundColor_workplace {
        background-color: #003e61;
      }
      &.backgroundColor_employment {
        background-color: #003e61;
      }
      &.backgroundColor_startBusiness {
        background-color: #003e61;
      }
    }
    .date {
      color: #2c3e50;
      text-align: initial;
    }
    .words,
    .title {
      text-align: initial;
    }
    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      white-space: normal;
      p {
        text-align: left;
      }
    }
  }
  @include sm {
    flex-direction: column;
    overflow: hidden;
    .content {
      padding: 10px 0 0;
      div {
        padding: 5px 0;
      }
    }
    .img {
      align-self: center;
      width: 100%;
      height: 100%;

      &:hover img {
        transform: scale(1);
      }

      img {
        width: 100%;
      }
    }
    .tag {
      margin-top: 10px;
    }
  }
}

.video {
  width: 470px;
  height: 100%;
  overflow: hidden;
  .iframe {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    :deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
